<template>
  <div
    class="empty-placeholder dash-card bg-white"
    v-if="loading && !errorLoading"
  >
    <b-spinner></b-spinner>
  </div>
  <b-button variant="primary" @click="getReferrals" v-else-if="errorLoading"
    >Network Error, Please Retry</b-button
  >

  <div
    v-else-if="referrals.length < 1"
    class="empty-placeholder dash-card bg-white"
  >
    You have not referred anyone
  </div>
  <b-row v-else>
    <b-col cols="12">
      <div class="list dash-card p-3 w-100 bg-white mb-2">
        <b-row>
          <b-col style="font-weight:bold">Name</b-col>
          <b-col style="font-weight:bold">Has Invested</b-col>
          <b-col style="font-weight:bold">Register date</b-col>
        </b-row>
      </div>
      <div
        class="list dash-card p-3 w-100 bg-white mb-2"
        v-for="referral in referrals"
        :key="referral.id"
      >
        <b-row>
          <b-col>{{ `${referral.firstname} ${referral.lastname}` }}</b-col>
          <b-col>{{ referral.hasinvested ? "Yes" : "No" }}</b-col>
          <b-col>
            {{
              LuxonDateTime.fromJSDate(new Date(referral.createdat)).toFormat(
                "LLL dd yyyy"
              )
            }}
          </b-col>
        </b-row>
      </div>
    </b-col>
    <b-col cols="12">
      <b-pagination
        v-if="total != 0"
        v-model="page"
        align="right"
        @change="pageChange"
        :total-rows="total"
        :per-page="perPage"
      ></b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import { DateTime as LuxonDateTime } from "luxon";
import { UserService } from "@/services";
export default {
  name: "referral-list",
  props: ["q"],
  data() {
    return {
      referrals: [],
      perPage: 5,
      page: 1,
      lastPage: 1,
      total: 0,
      loading: false,
      errorLoading: false,
      LuxonDateTime: LuxonDateTime
    };
  },
  async created() {
    await this.getReferrals();
  },
  methods: {
    async getReferrals(curPage = 1) {
      this.errorLoading = false;
      this.loading = true;
      try {
        const {
          data: { data: referrals, lastPage, perPage, total }
        } = await UserService.getReferrals(curPage);
        this.referrals = referrals;
        this.perPage = perPage;
        this.lastPage = lastPage;
        this.total = total;
        this.loading = false;
      } catch (err) {
        this.errorLoading = true;
      }
    },
    async pageChange(page) {
      if (page == this.page) return;
      this.loading = true;
      await this.getReferrals(page);
      this.page = page;
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}
</style>
